import AuthService from "../../AuthService";

const venueHireDetails = {
  getVenueHireDetails(page) {
    return AuthService.get("/service/venue_hire_details?page=" + page);
  },
  showVenueHireDetails(id) {
    return AuthService.get("/service/venue_hire_details/" + id);
  },
  createVenueHireDetails(data) {
    return AuthService.post("/service/venue_hire_details", data);
  },
  updateVenueHireDetails(id, data) {
    return AuthService.put("/service/venue_hire_details/" + id, data);
  },
  deleteVenueHireDetails(id) {
    return AuthService.delete("/service/venue_hire_details/" + id);
  }
};
export default venueHireDetails;
